import { render, staticRenderFns } from "./QuestionInput.vue?vue&type=template&id=4c9d4372&"
import script from "./QuestionInput.vue?vue&type=script&lang=ts&"
export * from "./QuestionInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports